import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import DateRangeContext from "contexts/DateRangeContext";
import UserProductSalesCard from "components/Cards/UserProductSalesCard";
import { ClipLoader } from "react-spinners";

function UserProductStatsPage() {
  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [userData, setUserData] = useState({});
  const [showLoader, setShowLoader] = useState(true);

  const refreshData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/stores/${storeId}/user-product-sales`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        formatData(resp);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const formatData = (userProducts) => {
    let finalData = {};

    for (const product of userProducts) {
      if (!finalData[product.user_id])
        finalData[product.user_id] = {
          username: product.username,
          color: product.user_color,
          quantity: 0,
          total: 0,
          products: [],
        };
      finalData[product.user_id].quantity += Number(product.quantity);
      finalData[product.user_id].total += product.total;
      finalData[product.user_id].products.push(product);
    }
    setUserData(finalData);
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    refreshData();
  }, [storeId, dateRange]);

  return (
    <>
      <Container fluid>
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          Object.keys(userData).map((userId) => (
            <Row key={userId}>
              <Col key={`col-${userId}`} xs={12} md={12}>
                <UserProductSalesCard userData={userData[userId]} />
              </Col>
            </Row>
          ))
        )}
      </Container>
    </>
  );
}

export default UserProductStatsPage;
